export enum CalendarGridColumnName {
  Followed = 'followed',
  Date = 'dealDate',
  Description = 'description',
  Size = 'size',
  State = 'state',
  Ratings = 'ratings',
  TaxStatus = 'taxStatus',
  Type = 'type',
  ROP = 'orderPeriod',
  Sector = 'sector',
  Structure = 'dealStructure',
  Manager = 'seniorManager',
  Purpose = 'purpose',
  BankQualified = 'isBankQualified',
  ERP = 'isExtraordinaryCall',
  IssueType = 'issueType',
  ESG = 'esgCertification',
  SourceOfRepayment = 'sourceOfRepayment',
  Pricing = 'pricing',
  FirstCall = 'firstCallDate',
  FirstCouponDate = 'firstCouponDate',
  DatedDate = 'datedDate',
  DealStatus = 'dealStatus',
  Documents = 'combinedDocuments',
  Issuer = 'issuer',
  ParityPlus = 'parityPlus'
}

export enum CalendarGridFlexColumnName {
  Sector = 'sector',
  Purpose = 'purpose',
  BankQualified = 'isBankQualified',
  ERP = 'isExtraordinaryCall',
  IssueType = 'issueType',

  SourceOfRepayment = 'sourceOfRepayment',
  Pricing = 'pricing',
  FirstCall = 'firstCallDate',
  FirstCouponDate = 'firstCouponDate',
  DatedDate = 'datedDate',
  Documents = 'combinedDocuments',
  ESG = 'esgCertification',
  ParityPlus = 'parityPlus'
}

export enum CalendarGridColumnLabel {
  Sector = 'Sector',
  Purpose = 'Purpose',
  BankQualified = 'Bank Qualified',
  ERP = 'Extraordinary Redemption Provision',
  ESG = 'ESG',
  IssueType = 'Issue Type',
  SourceOfRepayment = 'Source of Repayment',
  FirstCall = 'First Call Date',
  FirstCouponDate = 'First Coupon Date',
  DatedDate = 'Dated Date',
  Documents = 'Documents',
  ROP = 'ROP',
  ParityPlus = 'Parity+'
}

export interface FlexColumn {
  label: CalendarGridColumnLabel;
  name: CalendarGridColumnName;
}

export const flexColumnDefaultOptions: FlexColumn[] = [
  {
    label: CalendarGridColumnLabel.FirstCall,
    name: CalendarGridColumnName.FirstCall
  },
  {
    label: CalendarGridColumnLabel.FirstCouponDate,
    name: CalendarGridColumnName.FirstCouponDate
  },
  {
    label: CalendarGridColumnLabel.DatedDate,
    name: CalendarGridColumnName.DatedDate
  },
  {
    label: CalendarGridColumnLabel.ERP,
    name: CalendarGridColumnName.ERP
  },
  {
    label: CalendarGridColumnLabel.BankQualified,
    name: CalendarGridColumnName.BankQualified
  },
  {
    label: CalendarGridColumnLabel.SourceOfRepayment,
    name: CalendarGridColumnName.SourceOfRepayment
  },
  {
    label: CalendarGridColumnLabel.Sector,
    name: CalendarGridColumnName.Sector
  },
  {
    label: CalendarGridColumnLabel.Purpose,
    name: CalendarGridColumnName.Purpose
  },
  {
    label: CalendarGridColumnLabel.IssueType,
    name: CalendarGridColumnName.IssueType
  },
  {
    label: CalendarGridColumnLabel.Documents,
    name: CalendarGridColumnName.Documents
  },
  {
    label: CalendarGridColumnLabel.ESG,
    name: CalendarGridColumnName.ESG
  },
  {
    label: CalendarGridColumnLabel.ROP,
    name: CalendarGridColumnName.ROP
  }
];

export enum MaturityAnalyticsColumnName {
  Spread = 'spread',
  Price = 'price',
  Coupon = 'coupon',
  Yield = 'yield'
}

export enum MonitorGridColumnName {
  Unfollow = 'unfollow',
  DealDate = 'dealDate',
  Size = 'size',
  Description = 'description',
  State = 'state',
  Ratings = 'ratings',
  TaxStatus = 'taxStatus',
  Type = 'type',
  Sector = 'sector',
  DealStructure = 'dealStructure',
  SeniorManager = 'seniorManager',
  OrderPeriod = 'orderPeriod',
  Timing = 'timing',
  Ticketing = 'ticketing',
  Orders = 'orders',
  Score = 'score',
  Own = 'own',
  Rating = 'rating',
  Status = 'status',
  Assignments = 'assignments',
  Documents = 'combinedDocuments'
}

export enum ManagerGridColumnName {
  DealSelector = 'dealSelector',
  DealDate = 'dealDate',
  Size = 'size',
  Description = 'description',
  State = 'state',
  Ratings = 'ratings',
  TaxStatus = 'taxStatus',
  Type = 'type',
  Sector = 'sector',
  DealStructure = 'dealStructure',
  SeniorManager = 'seniorManager',
  Status = 'status',
  DealStatus = 'dealStatus',
  ManagementStatus = 'managementStatus'
}

export enum BidcompGridColumnName {
  Selection = 'selection',
  DealDate = 'dealDate',
  SaleDate = 'saleDate',
  DealTime = 'dealTime',
  Size = 'size',
  Description = 'description',
  Issuer = 'issuer',
  State = 'state',
  Ratings = 'ratings',
  TaxStatus = 'taxStatus',
  Type = 'type',
  OfferingType = 'offeringType',
  Sector = 'sector',
  SeniorManager = 'seniorManager',
  Status = 'status',
  DealStatus = 'dealStatus',
  ManagementStatus = 'managementStatus',
  BidStatus = 'bidStatus',
  BidSubmitted = 'bidSubmitted'
}

export enum DealSummaryGridColumnName {
  Duration = 'duration',
  OAS = 'oas',
  MaturityDate = 'maturityDate',
  NumberBonds = 'numberBonds',
  Coupon = 'coupon',
  Yield = 'yield',
  Price = 'price',
  YieldToMaturity = 'yieldToMaturity',
  Note = 'note',
  BenchmarkSpread = 'benchmarkSpread',
  Cusip = 'cusip',
  PutDate = 'putDate',
  PresentValue = 'presentValue',
  TaxableTsyYield = 'taxableTsyYield',
  TaxableTsySpread = 'taxableTsySpread',
  TaxEqYld = 'taxEqYld',
  BumpCut = 'yieldSpreadBump',
  TaxEqSpread = 'taxEqSpread',
  ImpliedYield = 'impliedYield',
  ImpliedSpread = 'impliedSpread',
  Series = 'series',
  TaxType = 'taxType',
  SecurityType = 'securityType',
  // secondary pricing fields
  Bid = 'bid',
  Ask = 'ask',
  BidYTW = 'bidYTW',
  Insurer = 'insurer',
  LiquidityScore = 'liquidityScore',
  PricingDateTime = 'pricingDateTime',
  HistoricalPricing = 'historicalPricing'
}

export enum DealSummaryGridColumnLabel {
  Duration = 'Duration',
  OAS = 'OAS',
  MaturityDate = 'Maturity',
  Par = 'Par ($M)',
  Coupon = 'Coupon',
  Yield = 'Yield',
  Price = 'Price',
  YieldToMaturity = 'YTM',
  Note = 'Note',
  Cusip = 'CUSIP',
  PutDate = 'PUT Date',
  PresentValue = 'Principal Amount',
  MaturityValue = 'Maturity Value ($M)',
  USTYield = 'UST Yield',
  USTSpread = 'UST Spread',
  TaxEqYld = 'TEY',
  Spread = 'Spread',
  BumpCut = '(Bump)/Cut (bp)',
  TaxEqSpread = 'TES (bp)',
  ImpliedYield = 'Implied Yield',
  ImpliedSpread = 'Implied Spread (bp)',
  TesBenchmarkYear = 'TES Benchmark Year',
  ImpliedSpreadBenchmarkYear = 'Implied Spread Benchmark Year',
  Series = 'Series',
  TaxType = 'Tax Type',
  SecurityType = 'Security Type',
  // secondary pricing fields
  Bid = 'Bid',
  Ask = 'Ask',
  BidYTW = 'Bid YTW',
  Notes = 'Notes',
  LiquidityScore = 'Liquidity Score',
  PricingDateTime = 'Date/Time'
}

export enum DealSummaryGridColumnTooltip {
  TaxEqYld = 'Tax Equivalent Yield',
  TaxEqSpread = 'Tax Equivalent Spread (bp)'
}

export enum DealDetailsGridColumnLabel {
  Bonds = 'Par',
  PriceOrBasis = 'Price/Yield',
  ComputedPriceYield = 'Computed Price/Yield',
  TD = 'T/D',
  TDPercent = 'T/D (%)',
  Concession = 'Conc',
  Spread = 'Spread To',
  Presale = 'Presale',
  PriceToDate = 'Price to Date',
  Present = 'Present Value CAB',
  Insurance = 'Insurance',
  Term = 'Term',
  MMD = 'MMD',
  AddBid = 'Add Bid',
  BidNo = 'Bid No.',
  ParAmt = 'Par Amt (000’s)',
  GrossSpread = 'Gross Spread',
  NIC = 'NIC',
  TIC = 'TIC',
  Bid = 'Bid',
  BenchmarkCurve = 'Loading...',
  ParAmount = 'Par Amount',
  AverageLife = 'Average Life',
  BondYears = 'Bond Years',
  AccruedInterest = 'Accrued Interest',
  GrossInterest = 'Gross Interest',
  PremiumOrDiscount = 'Premium/ (Discount)',
  NetInterestCost = 'Net Interest Cost',
  maturityDate = 'Maturity Date',
  ChangeDescription = 'Change Description',
  OldValue = 'Old Value',
  NewValue = 'New Value',
  ChangeDateTime = 'Change Date and Time',
  UST = 'UST'
}

export enum DealDetailsGridColumnName {
  PriceOrBasis = 'priceOrBasis',
  ComputedPrice = 'computedPrice',
  TD = 'td',
  Concession = 'concession',
  Presale = 'presale',
  Insurance = 'hasInsurance',
  PriceToDate = 'priceToDate',
  Present = 'presentValue',
  Amount = 'amount',
  AddBid = 'addBid',
  BidNo = 'bidId',
  ParAmt = 'parAmount',
  Coupon = 'coupon',
  PriceYield = 'priceYield',
  ComputedPriceYield = 'computedPriceYield',
  GrossSpread = 'spread',
  NIC = 'nic',
  TIC = 'tic',
  Bid = 'bid',
  BenchmarkCurve = 'mmdRateValue',
  Spread = 'spreadTo',
  DollarBid = 'dollarBid',
  AverageLife = 'averageLife',
  BondYears = 'bondYears',
  AccruedInterest = 'accruedInterest',
  GrossInterest = 'grossInterestCost',
  PremiumOrDiscount = 'premiumOrDiscount',
  NetInterestCost = 'netInterest',
  maturityDate = 'maturityDate',
  ChangeDescription = 'changeDesc',
  OldValue = 'oldValue',
  NewValue = 'newValue',
  ChangeDateTime = 'changeDateTime',
  UST = 'ust'
}

export enum InsuranceTabGridColumnName {
  Amount = 'amount',
  Insurer = 'insurerCode',
  InsuranceTotal = 'insuranceTotal',
  MaturityDate = 'maturityDate',
  InsurancePerBond = 'insurancePerBond'
}

export enum InsuranceTabGridColumnLable {
  Amount = 'No. of Bonds',
  Insurer = 'Insurer',
  InsuranceTotal = 'Total Premium',
  MaturityDate = 'Maturity Date',
  InsurancePerBond = 'Prem Per Bond'
}

export enum ExceptionsGridColumnName {
  MaturityDate = 'maturityDate',
  HighCouponRate = 'highCouponRate',
  HighCouponType = 'highCouponType',
  LowCouponRate = 'lowCouponRate',
  LowCouponType = 'lowCouponType',
  HighDollarRate = 'highDollarRate',
  HighDollarType = 'highDollarType',
  LowDollarRate = 'lowDollarRate',
  LowDollarType = 'lowDollarType',
  Moody = 'moody',
  SP = 'sp',
  Fitch = 'fitch',
  Kroll = 'kroll'
}

export enum ExceptionsGridColumnLabel {
  MaturityDate = 'Maturity Date',
  HighCouponRate = 'High Rate',
  HighCouponType = 'High Coupon Type',
  LowCouponRate = 'Low Rate',
  LowCouponType = 'Low Coupon Type',
  HighDollarRate = 'High Rate',
  HighDollarType = 'High Dollar Type',
  LowDollarRate = 'Low Rate',
  LowDollarType = 'Low Dollar Type',
  Moody = 'Moody',
  SP = 'SP',
  Fitch = 'Fitch',
  Kroll = 'Kroll'
}

export enum TermBondGridColumnName {
  Amount = 'amount',
  MaturityDate = 'maturityDate',
  Coupon = 'coupon',
  PriceOrBasis = 'priceOrBasis',
  ComputedPriceYield = 'computedPrice',
  Concession = 'concession',
  TD = 'td'
}

export enum TermBondGridColumnLabel {
  Amount = 'Par',
  MaturityDate = 'Maturity',
  Coupon = 'Coupon',
  PriceOrBasis = 'Price/Yield',
  ComputedPriceYield = 'Comp Price/Yield',
  Concession = 'Conc',
  TD = 'T/D'
}

export enum AllocationsGridColumnName {
  Selection = 'selection',
  DesignationStatus = 'designationStatus',
  LmAllot = 'allotmentNumber',
  SeriesMaturityDate = 'maturityDisplayText',
  CUSIP = 'cusip',
  AllottedBonds = 'amount',
  SalesCredit = 'credit',
  BreakdownLastModified = 'breakdownLastModifiedUtcDateTime'
}

export enum DesignationsGridColumnName {
  DealDate = 'date',
  Size = 'size',
  Description = 'description',
  State = 'state',
  Ratings = 'ratings',
  TaxStatus = 'taxStatus',
  LeadManager = 'seniorManagerDepartment',
  SubmissionStatus = 'dealStatus',
  LastModified = 'desiLastModifiedUtcDateTime',
  TotalAmountDesignated = 'amountDesignated',
  RemainingAmountToDesignate = 'remainingAmountToDesignate',
  TotalAmountToDesignate = 'totalAmountToDesignate'
}

export enum DesignationStatus {
  Submitted = 'Submitted',
  Partial = 'Partial',
  NotSubmitted = 'Not Submitted',
  SyndicateEdit = 'Syndicate Edit',
  SyndicateEditMultiple = 'Syndicate Edit (Mult)',
  PartiallySubmitted = 'Partially Submitted'
}

export const enum DesignationsGridExcelColumns {
  Date = 'Date',
  SubmissionStatus = 'Submission Status',
  Size = 'Par ($M)',
  Description = 'Issue Description',
  State = 'State',
  Ratings = 'Ratings',
  TaxStatus = 'Tax Status',
  LeadManager = 'Lead Manager',
  TotalAmountToDesignate = 'Total Designation',
  RemainingAmountToDesignate = 'Remaining Designation',
  TotalAmountDesignated = 'Total Amount Designated',
  LastModified = 'Last Modified',
  Enhancement = 'Enhancement'
}
